import React from 'react';
import './SeoContent.css';
import { phoneNumbers } from '../../data/phoneNumbers';

const SeoContent = () => {
    return (
        <section className="seo-content-section">
            <div className="seo-container">
                <div className="seo-content-wrapper">

                    {/* ===== BLOCK 1: Main intro ===== */}
                    <h2>أفضل ونش انقاذ سيارات في مصر | خصم 50% | {phoneNumbers[0]}</h2>
                    <p>
                        إذا كنت تبحث عن <strong>ونش انقاذ سيارات</strong> موثوق وسريع، فنحن نقدم لك أفضل خدمات الإنقاذ وسحب السيارات المعطلة
                        في جميع أنحاء جمهورية مصر العربية. نحن نتفهم تماماً مدى التوتر الذي يصيبك عند تعطل سيارتك فجأة على الطريق، ولذلك
                        حرصنا على توفير خدمة <strong>ونش انقاذ 24 ساعة</strong> لتكون في خدمتك في أي وقت وأي مكان. فقط اتصل بنا على{' '}
                        <strong>{phoneNumbers[0]}</strong> وسنصلك في أسرع وقت. الأهم من ذلك أننا نقدم <strong>خصم 50%</strong> على جميع
                        خدماتنا لضمان حصولك على أفضل خدمة بأقل سعر.
                    </p>

                    {/* ===== BLOCK 2: Why us ===== */}
                    <h3>لماذا تختار ونش انقاذ إنقاذ سيارات؟</h3>
                    <ul>
                        <li><strong>استجابة فورية:</strong> بفضل انتشارنا الواسع في جميع المناطق، نصل إليك في وقت قياسي لا يتجاوز 20 دقيقة.</li>
                        <li><strong>خصم 50%:</strong> استفد الآن من عرض <strong>خصم 50%</strong> على جميع الخدمات باتصالك على <strong>{phoneNumbers[0]}</strong>.</li>
                        <li><strong>أمان تام:</strong> نستخدم أحدث الونشات الهيدروليكية ومعدات التثبيت لضمان نقل سيارتك بدون أي خدوش أو أضرار.</li>
                        <li><strong>تأمين شامل:</strong> جميع السيارات المنقولة مؤمّنة بالكامل أثناء الرحلة من شركات تأمين معتمدة.</li>
                        <li><strong>خدمات متكاملة:</strong> سحب السيارات، شحن البطاريات، تغيير الإطارات، توصيل الوقود، وفتح السيارات المغلقة.</li>
                        <li><strong>فريق محترف:</strong> سائقون مدربون ومعتمدون بخبرة أكثر من 15 عاماً في مجال إنقاذ السيارات.</li>
                        <li><strong>أسعار شفافة:</strong> عرض سعر واضح قبل تحرك الونش، بدون رسوم خفية أو مفاجآت.</li>
                        <li><strong>تواجد على مدار الساعة:</strong> 24/7 طوال أيام الأسبوع بما فيها الأعياد والعطلات الرسمية.</li>
                    </ul>

                    {/* ===== BLOCK 3: Services ===== */}
                    <h3>خدمات ونش الانقاذ الشاملة — اتصل {phoneNumbers[0]}</h3>
                    <p>
                        نقدم مجموعة متكاملة من خدمات الطوارئ للسيارات على مستوى جمهورية مصر العربية بأعلى معايير الجودة والأمان:
                    </p>
                    <ul>
                        <li>
                            <strong>سحب ونقل السيارات:</strong> نقل آمن لجميع أنواع السيارات — ملاكي، دفع رباعي (SUV)، ميني باصات، شاحنات خفيفة،
                            دراجات نارية، سيارات فارهة (Mercedes, BMW, Porsche, Audi, Ferrari)، وسيارات كلاسيكية — باستخدام ونشات هيدروليكية حديثة وونشات
                            مسطحة (Flatbed) متخصصة مع أغطية واقية.
                        </li>
                        <li>
                            <strong>شحن بطارية السيارة:</strong> نصل إليك خلال 20 دقيقة بمعدات شحن احترافية. إذا كانت البطارية تالفة تماماً،
                            نوصل بطارية جديدة ونركبها في الموقع.
                        </li>
                        <li>
                            <strong>تغيير الإطارات:</strong> تغيير الإطار المثقوب في الموقع بأدوات متخصصة. إذا لم يكن هناك إطار احتياطي،
                            ننقل السيارة إلى أقرب مركز خدمة.
                        </li>
                        <li>
                            <strong>توصيل الوقود:</strong> نوصل بنزين 80، 92، 95، وديزل إلى موقعك مباشرةً في أقل من 20 دقيقة.
                        </li>
                        <li>
                            <strong>فتح السيارات المغلقة:</strong> نسيت مفتاح سيارتك بداخلها؟ نفتحها بأدوات متخصصة دون خدش متاح 24 ساعة.
                        </li>
                        <li>
                            <strong>انتشال السيارات العالقة:</strong> لدينا المعدات والخبرة لانتشال السيارات العالقة في الرمال أو الأماكن الوعرة.
                        </li>
                        <li>
                            <strong>نقل بين المحافظات:</strong> نقل السيارات من وإلى جميع محافظات مصر بأسعار تنافسية وخصم 50%.
                        </li>
                    </ul>

                    {/* ===== BLOCK 4: Areas ===== */}
                    <h3>مناطق تغطية ونش الإنقاذ السريعة في القاهرة والجيزة</h3>
                    <p>
                        إذا تعطلت سيارتك في القاهرة الجديدة، فنحن نوفر <strong>ونش انقاذ التجمع الخامس</strong>،
                        و<strong>ونش انقاذ التجمع الاول</strong>، و<strong>ونش انقاذ التجمع الثالث</strong> — مع خصم 50% واتصال على{' '}
                        <strong>{phoneNumbers[0]}</strong>. كما نغطي بالكامل مناطق مدينة نصر بأسطول من الونشات المجهزة، يمكنك طلب{' '}
                        <strong>ونش انقاذ مدينه نصر</strong> في أي وقت.
                    </p>
                    <p>
                        لعملائنا في المعادي وضواحيها، نوفر <strong>ونش انقاذ المعادي</strong>، و<strong>ونش انقاذ زهراء المعادي</strong>،
                        و<strong>ونش انقاذ صقر قريش</strong>. وإذا كنت على الطريق السريع، لدينا <strong>ونش انقاذ طريق السخنه</strong>{' '}
                        و<strong>ونش انقاذ طريق السويس</strong> جاهزان للتحرك الفوري. كذلك نغطي <strong>ونش انقاذ مصر الجديده</strong>،
                        و<strong>ونش انقاذ شيراتون</strong>، و<strong>ونش انقاذ النزهه</strong>، و<strong>ونش انقاذ القطاميه</strong>،
                        و<strong>ونش انقاذ المقطم</strong>، و<strong>ونش انقاذ العباسيه</strong>.
                    </p>

                    <h3>تغطية موسعة للمدن الجديدة والمحافظات</h3>
                    <p>
                        امتدت خدماتنا لتشمل المدن الجديدة: <strong>ونش انقاذ مدينتي</strong>، <strong>ونش انقاذ الرحاب</strong>،
                        <strong> ونش انقاذ العاصمه الاداريه</strong>، <strong>ونش انقاذ العبور</strong>، و<strong>ونش انقاذ السلام</strong>.
                        وفي محافظة الجيزة: <strong>ونش انقاذ اكتوبر</strong> و<strong>ونش انقاذ الشيخ زايد</strong>. ولعملائنا في المحافظات
                        الساحلية: <strong>ونش انقاذ اسكندريه</strong> و<strong>ونش انقاذ الساحل الشمالي</strong> لخدمة المصطافين والمسافرين.
                    </p>

                    {/* ===== BLOCK 5: Emergency types ===== */}
                    <h3>أنواع حالات الطوارئ التي نتعامل معها | {phoneNumbers[0]}</h3>
                    <p>
                        <strong>تعطل المحرك:</strong> إذا توقف محرك سيارتك فجأة بسبب ارتفاع درجة الحرارة، أو مشكلة في الوقود، أو عطل ميكانيكي،
                        فريقنا يصل إليك فوراً وينقل سيارتك إلى أقرب ورشة موثوقة. اتصل على <strong>{phoneNumbers[0]}</strong>.
                    </p>
                    <p>
                        <strong>نفاد البطارية:</strong> البطارية الفارغة من أكثر المشاكل شيوعاً، خاصة في الصباح الباكر والطقس البارد.
                        نوفر خدمة شحن البطارية السريعة أو توصيل بطارية جديدة وتركيبها في الموقع بخصم <strong>50%</strong>.
                    </p>
                    <p>
                        <strong>ثقب الإطار:</strong> إذا تعرض إطار سيارتك للثقب، نغير الإطار في الموقع أو ننقل سيارتك إلى أقرب مركز خدمة
                        إطارات. الاتصال على <strong>{phoneNumbers[0]}</strong>.
                    </p>
                    <p>
                        <strong>حوادث الطرق:</strong> في حالة الحوادث، نوفر خدمة إنقاذ متخصصة للسيارات المتضررة مع مراعاة جميع إجراءات
                        السلامة ونقل السيارة بعناية فائقة إلى الورشة أو موقع التأمين.
                    </p>
                    <p>
                        <strong>السيارات العالقة:</strong> إذا علقت سيارتك في الرمال، الطين، أو أي مكان وعر، لدينا المعدات المتخصصة
                        والخبرة لانتشالها بأمان.
                    </p>

                    {/* ===== BLOCK 6: Car brands ===== */}
                    <h3>أنواع السيارات التي نخدمها</h3>
                    <p>
                        نمتلك أسطولاً متنوعاً من الونشات لخدمة جميع أنواع المركبات:
                    </p>
                    <ul>
                        <li><strong>سيارات ملاكي:</strong> Toyota Corolla, Hyundai Elantra, Kia Cerato, Nissan Sunny, Skoda Octavia, Volkswagen Jetta, Honda Civic, Chevrolet Cruze وغيرها.</li>
                        <li><strong>سيارات دفع رباعي (SUV):</strong> Toyota Land Cruiser, Nissan Patrol, Jeep Wrangler, Mitsubishi Pajero, Toyota Fortuner, Ford Explorer وغيرها.</li>
                        <li><strong>سيارات فارهة:</strong> Mercedes, BMW, Audi, Porsche, Ferrari, Lamborghini, Rolls Royce, Bentley — ننقلها بونش Flatbed مع أغطية واقية خاصة.</li>
                        <li><strong>ميني باصات وشاحنات خفيفة</strong></li>
                        <li><strong>دراجات نارية وكرفانات</strong></li>
                    </ul>

                    {/* ===== BLOCK 7: How it works ===== */}
                    <h3>كيف نضمن وصولنا إليك في أقل من 20 دقيقة؟</h3>
                    <p>
                        نعتمد على استراتيجية التموضع الذكي — لدينا ونشات متمركزة في نقاط استراتيجية في جميع المناطق، ونستخدم نظام GPS متطور
                        لتتبع الونش الأقرب لموقعك في الوقت الفعلي. فريقنا يتابع حركة المرور لحظياً ويختار أسرع المسارات البديلة لتجنب
                        الازدحام. هذا يضمن وصولنا إليك في <strong>أقل من 20 دقيقة</strong> في معظم الأحيان. اتصل على <strong>{phoneNumbers[0]}</strong>{' '}
                        أو <strong>{phoneNumbers[1]}</strong> أو <strong>{phoneNumbers[2]}</strong>.
                    </p>

                    {/* ===== BLOCK 8: Safety ===== */}
                    <h3>نصائح السلامة عند تعطل سيارتك على الطريق</h3>
                    <ul>
                        <li>ركن السيارة على جانب الطريق بعيداً عن حركة المرور قدر الإمكان.</li>
                        <li>قم بتشغيل أضواء الانتظار (الفلشر) فوراً لتنبيه السائقين الآخرين.</li>
                        <li>إذا كنت على طريق سريع، ابق داخل السيارة وأغلق الأبواب، أو قف خلف الحاجز الخرساني بعيداً عن المركبات.</li>
                        <li>ضع مثلثات تحذير خلف سيارتك إذا توفرت معك، خاصة على الطرق السريعة.</li>
                        <li>لا تقبل مساعدة من سيارات غير معروفة وتأكد من هوية سائق الونش عند وصوله.</li>
                        <li>اتصل فوراً على <strong>{phoneNumbers[0]}</strong> وسنرسل إليك أقرب ونش انقاذ.</li>
                    </ul>

                    {/* ===== BLOCK 9: Guarantee ===== */}
                    <h3>ضمانات خدمة ونش الانقاذ | خصم 50% | {phoneNumbers[0]}</h3>
                    <p>
                        نلتزم بتقديم خدمة ونش انقاذ بأعلى معايير الجودة والأمان. ضماناتنا لك:
                        <strong> وصول خلال 20 دقيقة</strong> — أسعار شفافة بدون رسوم خفية — سيارتك مؤمّنة بالكامل أثناء النقل — فريق محترف
                        ومدرب — خصم 50% على جميع الخدمات. احفظ رقمنا <strong>{phoneNumbers[0]}</strong> في هاتفك للطوارئ، ولا تتردد في
                        الاتصال بأسرع ونش انقاذ سيارات في مصر. نحن نهتم بسلامتك ونسعى دائماً لتقديم الأفضل.
                    </p>

                    {/* ===== BLOCK 10: CTA ===== */}
                    <h3>اتصل الآن واحصل على خصم 50% | {phoneNumbers[0]}</h3>
                    <p>
                        لا تتردد في الاتصال بنا في أي وقت من اليوم أو الليل. خدمة الطوارئ الخاصة بنا متاحة على مدار الساعة وفريقنا
                        جاهز دائماً للاستجابة لطلبك بأسرع وقت ممكن. نحن على بعد مكالمة واحدة فقط! اتصل الآن على{' '}
                        <strong>{phoneNumbers[0]}</strong> أو <strong>{phoneNumbers[1]}</strong> أو <strong>{phoneNumbers[2]}</strong>{' '}
                        أو راسلنا عبر واتساب للحصول على مساعدة فورية وخصم <strong>50%</strong> على خدمتك.
                    </p>

                </div>
            </div>
        </section>
    );
};

export default SeoContent;
